import { buildFacetDesignOverrideLite } from 'src/Packages/FacetRest/FacetDesignOverrideLite';

export const UserReportOverride = buildFacetDesignOverrideLite();
